import { countryGetAllForDropdown } from "@/api/country";

const state = {
    countryOptions: null
};

const mutations = {
    GET_ALL_OPTIONS: (state, data) => {
        state.countryOptions = data;
    },
};

const actions = {
    async countryGetAllForDropdown({ commit }) {
        let res = await countryGetAllForDropdown();
        if (res) {
            commit("GET_ALL_OPTIONS", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/country.js